/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 *
 * Mirrors api-insights src/api/app/admin/users/import/_shared/types.ts.
 */

export const IMPORT_FIELDS = ['email', 'firstName', 'lastName', 'company', 'username', 'dashboard'] as const
export type ImportField = (typeof IMPORT_FIELDS)[number]

/** The most rows one import takes — the server's cap. */
export const MAX_IMPORT_ROWS = 500

export interface ImportRowInput {
  email: string
  firstName: string
  lastName: string
  company: string
  username: string
  dashboard: string
  /** Pick among Fresh users sharing the email; 0 creates a new account. */
  freshUserId?: number
  /** Pick among profiles sharing the dashboard email. */
  dashboardSourceUid?: string
}

export type ImportAction = 'create' | 'createSso' | 'grant' | 'skip' | 'error'

export interface ImportIssue {
  level: 'error' | 'warning' | 'info'
  code: string
  message: string
  field?: ImportField
}

export interface FreshCandidate {
  userId: number
  username: string
  firstName: string
  lastName: string
  companyName: string | null
}

export interface DashboardCandidate {
  uid: string
  displayName: string | null
  customerId: number | null
  dashboardCount: number
}

export interface ImportRowResult {
  row: number
  action: ImportAction
  issues: ImportIssue[]
  companyId?: number
  customerId?: number | null
  freshUserId?: number
  freshCandidates?: FreshCandidate[]
  dashboardSourceUid?: string
  dashboardCount?: number
  dashboardCandidates?: DashboardCandidate[]
}

export type ImportOutcome = 'created' | 'granted' | 'skipped' | 'failed'

export interface ImportCommitResult {
  row: number
  email: string
  outcome: ImportOutcome
  uid?: string
  emailSent?: boolean
  setPasswordUrl?: string
  message?: string
}

/** Rows that will write something when imported. */
export const WRITES: ImportAction[] = ['create', 'createSso', 'grant']
